import { createFileRoute, redirect } from '@tanstack/react-router';

/** The editor moved with the Forms module; old editor links keep working. */
export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId')({
    beforeLoad: ({ params, search }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/claims-products/forms/$formDefinitionId',
            params,
            // The editor's `view` param survives the move.
            search: search as never,
            replace: true,
        });
    },
});
